import { InteractiveContainer } from "@jugl-web/ui-components";
import { cx } from "@jugl-web/utils";
import { FC } from "react";

export interface ChatSuggestionPillsProps {
  suggestions: string[];
  className?: string;
  onSelect: (suggestion: string) => void;
}

export const ChatSuggestionPills: FC<ChatSuggestionPillsProps> = ({
  suggestions,
  className,
  onSelect,
}) => (
  <div className={cx("flex flex-wrap justify-center gap-2.5", className)}>
    {suggestions.map((suggestion, index) => (
      <InteractiveContainer
        key={+index}
        className={cx(
          "flex h-[34px] items-center justify-center overflow-hidden rounded-3xl px-[18px] transition-colors",
          "border border-solid border-grey-300 bg-white text-dark hover:border-[#2C2E2E] hover:bg-[#2C2E2E] hover:text-white"
        )}
        title={suggestion}
        onClick={() => {
          onSelect(suggestion);
        }}
      >
        <span className="truncate font-secondary text-[13px] font-medium">
          {suggestion}
        </span>
      </InteractiveContainer>
    ))}
  </div>
);
